import { render, staticRenderFns } from "./CustomerClosedTickets.vue?vue&type=template&id=537ac0f0&scoped=true"
import script from "./CustomerClosedTickets.vue?vue&type=script&lang=js"
export * from "./CustomerClosedTickets.vue?vue&type=script&lang=js"
import style0 from "./CustomerClosedTickets.vue?vue&type=style&index=0&id=537ac0f0&prod&lang=sass&scoped=true"
import style1 from "./CustomerClosedTickets.vue?vue&type=style&index=1&id=537ac0f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537ac0f0",
  null
  
)

export default component.exports